import { IGetAppTableInlineStylesParams} from './AppTable.interfaces';

export const getAppTableInlineStyles = (params: IGetAppTableInlineStylesParams) => {
  return {
    width: params.width || '100%',
    minWidth: params.minWidth || '768px',
    maxWidth: params.maxWidth || '1280px',
  };
};
